<child-header title="Microsoft Customer Agreement" (closeEvent)="closeAgreementPopup()"></child-header>

<div mat-dialog-content>
  <p>
    Please provide the end user details of the customer representative accepting the <a id="msCloudAgreementLink"
      style="color:#C20047 !important;text-decoration: none" href="{{data?.link}}" target="_blank">
      Microsoft Customer Agreement.
    </a>
  </p>

    <div id="agreementinfo" [formGroup]="agreement">
      <mat-form-field>
        <input matInput class="firstNameValidatePopup" placeholder="First name" formControlName="firstName" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput class="lastNameValidatePopup" placeholder="Last name" formControlName="lastName" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput class="emailValidatePopup" placeholder="Email" formControlName="email" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Phone" (keypress)="isNumberKey($event)" formControlName="phone">
      </mat-form-field>
    </div>
    
  </div>
  <div mat-dialog-actions class="save-button-position">
    <button class="saveupdate button button-red button-large save-button-margin"
      (click)="saveUpdates()">Save and continue</button>
    <button class="button button-red button-large" *ngIf="data?.status == 'Success'"
      (click)="closeAgreementPopup()">CLOSE</button>
    <button class="button button-red button-large" *ngIf="data?.status == 'Fail' || data?.status == 'MCA'"
      (click)="goback()">{{type}}</button>
  </div>
  <loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth="600"
    (currentLoadingStatus)="onLoading($event)"></loading-screen>
